// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB7QZJ3kwDgmEIbbM89jZf8fjL4TOzGT1Q",
  authDomain: "zafflostarter.firebaseapp.com",
  projectId: "zafflostarter",
  storageBucket: "zafflostarter.firebasestorage.app",
  messagingSenderId: "989600735978",
  appId: "1:989600735978:web:5d2418bf920fbfbedded93",
  measurementId: "G-JB13HSTHXW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export {db, storage}